import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {ProteinAlignmentRow} from 'constants/AlignmentConstants';
import ProteinAlignmentStats from 'molbio/aa-sequences/alignments/AaSequenceAlignmentStats';
import ProteinAlignmentRowsView from 'molbio/maps/alignment/AaSequenceAlignmentRowsView';
import ProteinAlignmentRowView from 'molbio/maps/alignment/AaSequenceAlignmentRowView';
import PolymerAlignmentTabView from 'molbio/maps/alignment/PolymerAlignmentTabView';
import AlignmentSummaryMapView from 'molbio/maps/alignment/summary/AlignmentSummaryMapView';
import {MIN_WIDTH_FOR_INDEX} from 'molbio/maps/linear/AntibodyNumbering';
import Type from 'molbio/maps/Type';
import ProteinAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export default class ProteinAlignmentTabView extends PolymerAlignmentTabView<
  ProteinAlignmentRow,
  ProteinAlignmentTabState
> {
  addPolymersForSearch(): void {
    // TODO
  }

  removePolymersForSearch(): void {
    // TODO
  }

  getType(): Type {
    return this.model.getType();
  }

  setType(typeObj: Type): void {
    this.model.setType(typeObj);
  }

  getPolymerLength(): number {
    return this.model.getPolymerLength();
  }

  override renderStatsView(): JSX.Element | null {
    if (this.shouldCollapseMiniMap(this.model)) {
      return null;
    }

    return (
      <ProteinAlignmentStats
        alignment={this.model.get('alignment')!}
        selectionStart={this.model.get('selection').start()}
        selectionEnd={this.model.get('selection').end()}
      />
    );
  }

  makeSummaryMapView(): AlignmentSummaryMapView<ProteinAlignmentRow> {
    return new AlignmentSummaryMapView({
      model: null,
      tabstate: this.model,
      topY: ['summaryIdentityGraph', 'line'],
      middleY: ['line'],
      bottomY: [],
      padding: 172, // Keep in sync with @handle-width + 2
      isCollapsed: this.shouldCollapseMiniMap(this.model),
    });
  }

  makeRowsView(): ProteinAlignmentRowsView {
    return new ProteinAlignmentRowsView({model: this.model});
  }

  makeTopAlignmentRowView(): ProteinAlignmentRowView {
    return new ProteinAlignmentRowView({
      model: this.model,
      tabstate: this.model,
      row: this.model.get('alignment')!.rows[0],
      alignmentType: this.model.get('alignment')!.alignmentType,
      visibilityOptions: this.model.get('localVisibilityOptionsList')![0],
    });
  }

  override registerListeners(): void {
    super.registerListeners();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'change:alignment', this.update);
  }

  override getDefaultSpan(): number {
    if (
      BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_ENGINEERING_TOOLS &&
      !BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_ENTITIES &&
      this.model.get('visibilityOptions').getOption(vo.ANTIBODY_NUMBERING.name)!.get('visible')
    ) {
      return Math.floor(this.mapWidth() / (MIN_WIDTH_FOR_INDEX + 1));
    }

    return super.getDefaultSpan();
  }

  getDataTestAttrs(): DataTestAttrs {
    return {component: 'ProteinAlignmentTab', element: 'root'};
  }
}
